import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Slides from '@ifeng/ui_pc_slides';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { shopTitle0, shopList0, shopListAd },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="230179" type="struct" title="凰家尚品标题" groupName="凰家尚品" content={shopTitle0}>
                    <NewsTitle size="middle" isAd={true} />
                </Chip>
                <Chip
                    id="260557"
                    type="struct"
                    title="凰家尚品列表1"
                    groupName="凰家尚品"
                    content={shopList0}
                    translate="handleShopStructData">
                    <NewsList hasTitleImg size="long" ad={shopListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
